import type { components } from "admination-react/api-schema";
import { apiFetch, buildUrl, getJson, sendJson, type WriteIdentity } from "./http";

export type AppLinkResolveResult = components["schemas"]["AppLinkResolveRead"];

export function resolveAppLinkOnGate(token: string): Promise<AppLinkResolveResult> {
  return sendJson<AppLinkResolveResult>("/portal/app-link-resolve", "POST", { token });
}

export type DatenschutzConsent = components["schemas"]["DatenschutzConsentRead"];

export function fetchDatenschutzConsentOnGate(coachingId: string): Promise<DatenschutzConsent> {
  return getJson<DatenschutzConsent>("/portal/datenschutz-consent", {
    coaching_id: coachingId,
  });
}

export function fetchDatenschutzInfoOnGate(coachingId: string): Promise<Response> {
  return apiFetch(buildUrl("/portal/datenschutz-info", { coaching_id: coachingId }), {
    method: "GET",
    credentials: "include",
  });
}

export type ParticipantLinkZweck = NonNullable<components["schemas"]["ParticipantLinkIn"]["zweck"]>;

export type ParticipantLinkMinted = components["schemas"]["ParticipantLinkRead"];

export function createParticipantLink(
  coachingId: string,
  zweck?: ParticipantLinkZweck,
  reminder?: boolean,
  identity?: WriteIdentity,
): Promise<ParticipantLinkMinted> {
  return sendJson<ParticipantLinkMinted>("/portal/participant-link", "POST", {
    coaching_id: coachingId,
    ...(zweck ? { zweck } : {}),
    ...(reminder ? { reminder: true } : {}),
  }, undefined, identity);
}

export type SignDatenschutzResult = components["schemas"]["SignDatenschutzRead"];

export function signDatenschutzOnGate(
  coachingId: string,
  signaturePng: string
): Promise<SignDatenschutzResult> {
  return sendJson<SignDatenschutzResult>("/portal/sign-datenschutz", "POST", {
    coaching_id: coachingId,
    signature_png: signaturePng,
  });
}

export type SignAnwesenheitslisteResult = components["schemas"]["SignAnwesenheitslisteRead"];

export function signAnwesenheitslisteOnGate(
  coachingId: string,
  signaturePng: string
): Promise<SignAnwesenheitslisteResult> {
  return sendJson<SignAnwesenheitslisteResult>("/portal/sign-anwesenheitsliste", "POST", {
    coaching_id: coachingId,
    signature_png: signaturePng,
  });
}

export function signNachweisOnGate(nachweisId: string, signaturePng: string): Promise<void> {
  return sendJson<void>("/portal/sign-nachweis", "POST", {
    nachweis_id: nachweisId,
    signature_png: signaturePng,
  });
}

export type SignVertragResult = components["schemas"]["SignVertragRead"];

export function signVertragOnGate(
  coachingId: string,
  signaturePng: string
): Promise<SignVertragResult> {
  return sendJson<SignVertragResult>("/portal/sign-vertrag", "POST", {
    coaching_id: coachingId,
    signature_png: signaturePng,
  });
}

export function participantCompleteOnGate(coachingId: string): Promise<void> {
  return sendJson<void>("/portal/participant-complete", "POST", {
    coaching_id: coachingId,
  });
}
